import { IProductRelease, IProductReleases } from "../models";
import FetchError from "./errors";
import { customFetchWithRetry, getAuthHeaders } from "./shared";

export const getProductReleases = async (productId: string, requireAuth: boolean = false): Promise<IProductRelease[] | null> => {
  try {
    const headers = requireAuth ? await getAuthHeaders(true) : await getAuthHeaders(false);
    const response = await customFetchWithRetry(`/product/${productId}/release`, {
      method: "GET",
      headers,
    }, false)
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const generateUploadUrl = async (
  productId: string,
  releaseId: string,
  platform: string,
  moduleName: string
): Promise<{ uploadUrl: string; fileKey: string }> => {
  try {
    const headers = await getAuthHeaders(true);
    const response = await customFetchWithRetry(
      `/product/${productId}/release/${releaseId}/upload-url?platform=${platform}&moduleName=${moduleName}`,
      {
        method: "POST",
        headers,
      },
      false
    );
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error generating upload URL. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const confirmEncryptedUpload = async (
  productId: string,
  releaseId: string,
  platform: string,
  moduleName: string,
  fileKey: string
): Promise<{ message: string }> => {
  try {
    const headers = await getAuthHeaders(true);
    const response = await customFetchWithRetry(
      `/product/${productId}/release/${releaseId}/encrypted-module`,
      {
        method: "PUT",
        headers,
        body: JSON.stringify({ platform, moduleName, fileKey }),
      },
      false
    );
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error confirming upload. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const updateProductRelease = async (productId: string, releaseId: string, changeLog: string): Promise<IProductRelease | null> => {
  try {
    const response = await customFetchWithRetry(`/product/${productId}/release/${releaseId}`, {
      method: "PUT",
      body: JSON.stringify({ changeLog }),
      headers: {
        'Content-Type': 'application/json',
      },
    }, false)
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error updating release. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};